import { COLORS } from '@btime/constants'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { Title } from '../../../packages/kiti/components/presentation/Text'
import { useCurrentModal } from '../../../components/modals/ModalsContext'
import Separator from '../../../packages/kiti/components/helpers/Separator'

const ModalHeader = () => {
  const { t } = useTranslation('screenViews')
  const {
    data: { id }
  } = useCurrentModal()

  return (
    <>
      <Title size="h4" color="dark1" align="center" noMargin>
        {t('title')}
      </Title>
      <Separator weight={6} />
    </>
  )
}

export default ModalHeader
